import { GET_COMPANY } from "../../features/graphql/query/company"
import { useLazyQuery, useQuery, useMutation } from "@apollo/client"
import { useEffect } from "react"
import { useParams } from "react-router"
import { ApiValidationError, Header, HeaderActionType, LoadingWrapper, mapApiFieldValidationErrors } from "ui"
import { useCompany } from "../../context/CompanyContext"
import { Grid, Card, Paper } from "@mui/material"
import { useNavigate } from "react-router"
import { CompanyType, EditCompanyMutation, EditCompanyMutationVariables, Location } from "../../__generated__/graphql"
import { useLocation } from "../../context/LocationContext"
import { EDIT_COMPANY_MUTATION, CompanyForm, CompanyFormSchema, SubscriptionTable, LocationTable } from "ft-shared-graphql"
import { FormSubmitCallback, useManageModal } from "ui"
import { TableChart, People, Groups, QuestionMark } from "@mui/icons-material"
import { SAMPLE_SLIDE_IN } from "../components/TestSlideIn/contentTypes"
import { useTestSlideInContext } from "../../context/TestSlideInContext"
interface CompanyPageProps {
    onBack: () => void
}
export default function CompanyPage({ onBack }: CompanyPageProps) {
    const { id } = useParams()
    const navigate = useNavigate()
    const { handleContent } = useTestSlideInContext()
    const { company, setCompany } = useCompany()
    const { setLocation } = useLocation()
    const [fetchCompany, { loading, data }] = useLazyQuery(GET_COMPANY, {
        notifyOnNetworkStatusChange: true
    })
    const { openModal } = useManageModal()
    useEffect(() => {
        if (!company) {
            fetchCompany({ variables: { id } })
        }
        if (data?.company) {
            console.log(data?.company)
            setCompany(data.company)
        }
    }, [company, data])
    const [editCompany] = useMutation<EditCompanyMutation, EditCompanyMutationVariables>(EDIT_COMPANY_MUTATION,
    );
    const handleSelectedLocation = (location: Location) => {
        setLocation(location)
        navigate(`/location/${location?.id}`);
    }
    const handleEditCompanyInformation: FormSubmitCallback<CompanyFormSchema> = async (values: any): Promise<ReturnType<FormSubmitCallback>> => {
        const typeParsed = values.type as CompanyType
        const input = {
            id: id,
            name: values.name,
            abbreviation: values.abbrv,
            type: typeParsed,
            needParentalConsent: values.needParentalConsent,
            autoParentalConsent: values.autoParentalConsent,
            timeoutWindow: parseInt(values.timeoutWindow),
            abuseAtHome: values.abuseAtHome,
            safeAtHome: values.safeAtHome,
            suicide: values.suicide,
            paidUsers: parseInt(values.paidUsers),
        }
        const response = await editCompany({ variables: { input }, refetchQueries: [GET_COMPANY] })
        if (response.data?.editCompany.errors) {
            const validationError = response.data.editCompany.errors
                .find(e => e.__typename === "ValidationError") as ApiValidationError;
            const fieldErrors = validationError
                ? mapApiFieldValidationErrors(validationError)
                : null;

            return fieldErrors;
        } else {
            openModal({ type: "SAVED_CHANGES", cancelButtonLabel: "Close" })

            return;
        }
    }
    const goToStaffProgress = () => {
        navigate(`/staff/${id}`)
    }
    const goToCompanyStats = () => {
        navigate(`stats`)
    }
    const goToStudentInsights = () => {
        navigate(`students`)
    }
    const testSlideIn = () => {
        handleContent(SAMPLE_SLIDE_IN)
    }
    const HeaderActions: HeaderActionType[] = [{
        name: "Staff Statistics",
        icon: <People />,
        action: goToStaffProgress
    }, {
        name: "View Company Statistics",
        icon: <TableChart />,
        action: goToCompanyStats
    }, {
        name: "Student Insights",
        icon: <Groups />,
        action: goToStudentInsights
    }, {
        name: "TEST",
        icon: <QuestionMark />,
        action: testSlideIn
    }]
    return (
        <LoadingWrapper loading={!company}>
            {company ?
                (
                    <Card elevation={4}
                        style={{
                            width: "100%",
                            display: "flex", padding: "16px", height: "auto"
                        }}>
                        <Grid container spacing={2}>
                            <Grid size={12}>
                                <Header title={company?.name ?? ""} onBack={onBack}
                                    subtitle={`Paid Licenses: ${company?.paidUsers ?? 'N/A'}, Active Licenses: ${company?.activeUsers ?? 'N/A'}`}
                                    headerActions={HeaderActions}
                                />
                            </Grid>
                            <Grid size={6}>

                                {/* TODO: FORMATTING */}
                                <Grid container spacing={2}>
                                    <Grid size={12}>
                                        <Paper
                                            component="div" variant="outlined"
                                            sx={{ padding: "1rem" }}>
                                            <CompanyForm
                                                isDevPortal={true}
                                                readonly={company.companySubscriptions.every(e => e.status == "Expired") ? true : false}
                                                initialValues={{
                                                    name: company?.name ?? '',
                                                    abbrv: company?.abbreviation ?? '',
                                                    type: company?.type?.toUpperCase() ?? CompanyType.Other,
                                                    needParentalConsent: company?.companyConsentPolicy?.needParentalConsent ?? false,
                                                    autoParentalConsent: company?.companyConsentPolicy?.autoParentalConsent ?? false,
                                                    timeoutWindow: company?.companyConsentPolicy?.timeoutWindow ?? null,
                                                    abuseAtHome: company?.companyInterventionPolicy?.abuseAtHome ?? false,
                                                    safeAtHome: company?.companyInterventionPolicy?.safeAtHome ?? false,
                                                    suicide: company?.companyInterventionPolicy?.suicide ?? false,
                                                    paidUsers: company?.paidUsers ?? 0,
                                                }}
                                                onSubmit={handleEditCompanyInformation}
                                                onCancel={onBack}
                                            />
                                        </Paper>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid size={6}>
                                <Grid container spacing={2}>
                                    <Grid size={12}>
                                        <Paper component='div' variant="outlined">
                                            <SubscriptionTable
                                                company={company}
                                                showHeaderAction
                                                subscriptions={company!.companySubscriptions}
                                            /></Paper>
                                    </Grid>
                                    <Grid size={12}>

                                        <Paper component="div" variant="outlined">
                                            <LocationTable handleSelectedLocation={handleSelectedLocation} />
                                        </Paper>
                                    </Grid>
                                </Grid>

                            </Grid>
                        </Grid>
                    </Card>
                ) : null
            }
        </LoadingWrapper >)
}